// @ts-nocheck
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Tooltip from 'react-bootstrap/Tooltip'
import {Column} from 'react-table'
import {useDispatch, useSelector} from 'react-redux'
import {useState} from 'react'

import {PartyLedgerActionsCell} from './PartyLedgerActionsCell'
import {PartyLedgerCustomHeader} from './PartyLedgerCustomHeader'
import {PartyLedger} from '../../core/_models'
import {checkDisplayValue, formatDate} from '../../../../../../../utils'
import {constants} from '../../../../../../../utils/const'
import {toggleChecked, setReceiverId} from 'src/store/balanceShow/actions'
import BalanceComponent from '../../BalanceComponent'
import { CopyToClipboardIcon } from 'src/app/components/CopyToClipboardIcon'


const PartyLedgerColumns: ReadonlyArray<Column<PartyLedger>> = [
  {
    Header: (props) => {
      const { isCheckboxChecked, setIsCheckboxChecked, setSelectedRows } = props;
      
      return (
        <div className="text-right" style={{backgroundColor: '#e0e0e0',height: '51px',paddingTop:'15px',paddingLeft: '15px', cursor: 'pointer'}}>
          <OverlayTrigger
            placement="top"
            overlay={<Tooltip>Total Balance</Tooltip>}
          >
            <input
              type="checkbox"
              checked={isCheckboxChecked}
              onChange={(e) => {
                setIsCheckboxChecked(e.target.checked);
                if (e.target.checked && setSelectedRows) {
                  setSelectedRows([]);
                }
              }}
              style={{cursor: 'pointer'}}
            />
          </OverlayTrigger>
        </div>
      );
    },
    id: 'nselect',
    accessor: 'id',
    Cell: () => <div></div>,
    width: 50,
    className: 'text-center',
  },
  // {
  //   Header: (props) => {
  //     const { selectedRows = [], rows = [], handleSelectAll = () => {} } = props;
  //     // Filter out balance rows
  //     const dataRows = rows.filter(row => 
  //       !['Opening Balance', 'Current Balance', 'Closing Balance', 'Difference'].includes(row.original.message_id)
  //     );
      
  //     // Check if all data rows (excluding balance rows) are selected
  //     const allDataRowsSelected = dataRows.length > 0 && 
  //       dataRows.every(row => selectedRows.some(selected => selected.id === row.original.id));
      
  //     return (
  //       <div className="text-right" style={{backgroundColor: '#e0e0e0',height: '51px',paddingTop:'15px',paddingLeft: '15px', cursor: 'pointer'}}>
  //         <OverlayTrigger
  //           placement="top"
  //           overlay={<Tooltip>Select All (Ctrl + A)</Tooltip>}
  //         >
  //           <input
  //             type="checkbox"
  //             checked={allDataRowsSelected}
  //             onChange={handleSelectAll}
  //             style={{cursor: 'pointer'}}
  //           />
  //         </OverlayTrigger>
  //       </div>
  //     );
  //   },
  //   id: 'select',
  //   accessor: 'id',
  //   Cell: () => <div></div>,
  //   width: 50,
  //   className: 'text-center',
  // },
    // {
    //   Header: (props) => (
    //     <PartyLedgerCustomHeader
    //       tableProps={props}
    //       title={
    //         <div className='d-flex justify-content-end align-items-center'>
    //           <input
    //             type='checkbox'
    //             onChange={() => {
    //               // Implement select all logic here if needed
    //               props.toggleAllRowsSelected?.()
    //             }}
    //             className='me-2'
    //           />
    //         </div>
    //       }
    //       className='min-w-50px text-end'
    //     />
    //   ),
    //   id: 'selection',
    //   Cell: () => null, // No content in data rows
    //   width: 50,
    // },
  
  {
    Header: (props) => (
      <PartyLedgerCustomHeader tableProps={props} title='Date' className='min-w-120px' />
    ),
    accessor: 'created_at',
    Cell: ({value}) => (
      <>
      
        <div className='remarks-cell text-center'>
        {formatDate(value?.replace?.(' ', 'T'), constants.DATE_FORMAT.DD_MM_YYYY_HH_MM_SS)}
        </div>
      
      </>

    ),
  },

  {
    Header: (props) => (
      <PartyLedgerCustomHeader tableProps={props} title='Message Id' className='min-w-120px' />
    ),
    accessor: 'message_id',
    Cell: ({...props}) => {
      const row = props.data[props.row.index]
      return row.message_type === 2 ? null : checkDisplayValue(row.message_id)
    },
  },
  {
    Header: (props) => (
      <PartyLedgerCustomHeader tableProps={props} title='Credit' className='min-w-120px' />
    ),
    accessor: 'credit',
    Cell: ({value, row}) => constants.formatAmount(value),
  },
  {
    Header: (props) => (
      <PartyLedgerCustomHeader tableProps={props} title='Debit' className='min-w-90px' />
    ),
    accessor: 'debit',
    Cell: ({value, row}) => constants.formatAmount(value),
  },
  {
    Header: (props) => (
      <PartyLedgerCustomHeader tableProps={props} title='Balance' className='min-w-120px' />
    ),
    accessor: 'balance',
    Cell: ({value}) => constants.formatAmount(value),
  },
  {
    Header: (props) => (
      <PartyLedgerCustomHeader tableProps={props} title='Receiver' className='min-w-120px' />
    ),
    accessor: 'receiver',
    Cell: ({value, row}) => {
      const messageId = row.original.message_id
      const isSpecialMessage = ['Opening Balance', 'Current Balance', 'Closing Balance', 'Difference'].includes(messageId)
      
      if (row.original.message_type === 2) return null
      
      return (
        <div className='remarks-cell'>
          <span
            style={{
              color: isSpecialMessage ? 'inherit' : '#007bff',
              textDecoration: isSpecialMessage ? 'none' : 'underline',
              cursor: 'inherit',
              pointerEvents: isSpecialMessage ? 'none' : 'auto'
            }}
          >
            {checkDisplayValue(value)?.split(' - ')[0]}
          </span>
        </div>
      )
    },
  },
  {
    Header: (props) => (
      <PartyLedgerCustomHeader tableProps={props} title='Remarks' className='min-w-120px' />
    ),
    accessor: 'remarks',
    Cell: ({value, row}) => {
      // const [isCopied, setIsCopied] = useState(false);
      const [showIcon, setShowIcon] = useState(false);
      
      // Check if the row is a special message type
      const messageId = row.original.message_id;
      const isSpecialMessage = ['Opening Balance', 'Current Balance', 'Closing Balance', 'Difference'].includes(messageId);
      
      // If it's a special message or there's no value, just show a dash
      if (isSpecialMessage || !value) {
        return <div className='remarks-cell text-center'>-</div>;
      }
      return (
      <OverlayTrigger
        key='top'
        placement='top'
        overlay={
          <Tooltip id={`tooltip-top`}>
            {value}
          </Tooltip>
        }
      >
        <div 
          className='remarks-cell text-center d-flex align-items-center justify-content-center'
          onMouseEnter={() => setShowIcon(true)}
          onMouseLeave={() => setShowIcon(false)}
          style={{ cursor: 'pointer' }}
        >
          <span>
            {checkDisplayValue(value) && checkDisplayValue(value).length > 20
              ? checkDisplayValue(value).substring(0, 10) + '...'
              : checkDisplayValue(value)}{' '}
          </span>
          {showIcon && <CopyToClipboardIcon value={value} />}
        </div>
      </OverlayTrigger>
    );
    },
  },
  {
    Header: (props) => (
      <PartyLedgerCustomHeader
        tableProps={props}
        title='Actions'
        className='text-center min-w-100px'
      />
    ),
    id: 'actions',
    Cell: ({...props}) => (
      <PartyLedgerActionsCell
        id={props.data[props.row.index].id}
        message_id={props.data[props.row.index].message_id}
        message_uuid={props.data[props.row.index].message_uuid}
        data={props.data[props.row.index]}
      />
    ),
  },
]

export {PartyLedgerColumns}